module.exports = __webpack_public_path__ + "img/mixpanel-logo.466938b2.svg";